"use client";

import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import PropTypes from "prop-types";

import styles from "./styles.module.scss";
import services from "@/store/services";
import Components from "@/components";
import apis from "@/api";

const UNLOCK = 48;

function CertificateReqBtn(props) {
  const { courseInfo, isEnrolled } = useSelector((state) => state.video);
  const enrollments = useSelector((state) => state?.enrollment);
  const user = useSelector((state) => state?.user?.users);
  const [showCtfModal, setShowCtfModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const eligibilityData = useRef(null);

  const dispatch = useDispatch();
  const router = useRouter();

  const certificateEligibility = useCallback(async (courseProgress) => {
    let obj = {
      hasSeenAllVideos: false,
      sentStatus: false,
      feedbackShared: false,
    };
    if (courseProgress) {
      obj.hasSeenAllVideos =
        courseProgress.seenContents.length >=
        parseFloat(process.env.NEXT_PUBLIC_COURSE_COMPLETION_CRITERIA) *
          (courseInfo?.videoList.length || 0);
      if (!obj.hasSeenAllVideos) return obj;
      else {
        let sentStatus = courseProgress.certificate.status;
        if (sentStatus === process.env.NEXT_PUBLIC_CERTIFICATE_SENT_STATUS)
          return { ...obj, sentStatus: true };
        let feedbackShared = await apis.isUserFeedbackExist(
          courseInfo?._id,
          process.env.NEXT_PUBLIC_COURSE_FEEDBACK_TYPE
        );
        obj.feedbackShared = feedbackShared.status === 200;
        return obj;
      }
    } else return obj;
  }, []);

  const onNextButtonClick = async () => {
    if (!user?.email) {
      dispatch(services.toggleSigninModal());
      return;
    }
    setLoading(true);
    const courseProgress = enrollments?.find(
      (course) => course.courseId === courseInfo?._id
    );
    const eligibility = await certificateEligibility(courseProgress);
    eligibilityData.current = eligibility;
    setLoading(false);
  };

  const handleCertificateRequest = useCallback(async () => {
    if (!user?.email) {
      dispatch(services.toggleSigninModal());
      return;
    }
    try {
      setLoading(true);
      let courseProgress = enrollments?.find(
        (course) => course.courseId === courseInfo?._id
      );

      if (
        courseProgress?.certificate?.status === "SENT" &&
        courseProgress?.certificate?.id
      ) {
        router.push(`/certificate?id=${courseInfo?._id}`);
        return;
      } else {
        setShowCtfModal(true);
      }
    } catch (error) {
      console.error("Error in handleCertificateRequest", error);
      props.warningCallback({
        show: true,
        type: "error",
        name: error?.message || "Something went wrong. Please try again.",
        btnClick: "",
      });
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (isEnrolled?.courseId === courseInfo?._id) {
      const shouldShow =
        isEnrolled?.progress >
        parseFloat(process.env.NEXT_PUBLIC_COURSE_COMPLETION_CRITERIA) * 100 -
          10;
      if (
        isEnrolled.certificate.status ===
          process.env.NEXT_PUBLIC_CERTIFICATE_PENDING_STATUS &&
        shouldShow
      )
        dispatch(services.startCertificateTour());
    }
  }, [isEnrolled, courseInfo?._id]);

  return (
    <>
      {isEnrolled && (
        <>
          <Components.Tooltip
            placement="top"
            title={`${
              isEnrolled?.progress <= 0
                ? 0
                : isEnrolled?.progress > 100
                  ? 100
                  : isEnrolled?.progress
            }% Course completed 👍`}
          >
            <button
              className={`${styles["vd-request-btn"]}`}
              onClick={handleCertificateRequest}
              id="vd_Certificate_Request_Btn"
            >
              <span>Certificate</span>
              <div className={styles["button__progress"]}></div>
            </button>
          </Components.Tooltip>
        </>
      )}

      <Components.Modal
        showModal={showCtfModal}
        setShowModal={setShowCtfModal}
        heading={" "}
      >
        <Components.CtfEligibilityModal
          loading={loading}
          setShowCtfModal={setShowCtfModal}
          handleNextClick={onNextButtonClick}
          eligibility={eligibilityData.current}
        />
      </Components.Modal>
    </>
  );
}

CertificateReqBtn.propTypes = {
  warningCallback: PropTypes.func,
};

export default React.memo(CertificateReqBtn);
